import { useSelector } from 'react-redux';

import { selectIsLiveChat } from '../../common/selectors/chat';
import { selectFieldState } from '../../common/selectors/field';

export const useIsAttachmentAvailable = () => {
  const { disabled, attachFile } = useSelector(selectFieldState);
  const isLiveChat = useSelector(selectIsLiveChat);

  const isDisabled = disabled && !isLiveChat;
  return isLiveChat || (attachFile && !isDisabled);
};
